var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"eu-key__file-loader-wrapper eu-key__item_el"},[_c('FileUpload',{staticClass:"eu-key__file-loader",attrs:{"maxSizeKB":100,"isEuKey":""},on:{"remove":_vm.deleteEuKey}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }